module.exports = __webpack_public_path__ + "img/com14.5adfbd83.gif";